import React from "react";
import { Select } from "antd";
import ValidationsMessage from "../../helpers/shared/ValidationsMessage";

const { Option } = Select;

export default function VendorEditDetails({
  selectVendor,
  addForm,
  assetDetails,
  vendorInfo,
  isSubmit,
}) {
  return (
    <div className="row m-grid">
      <div className="col-md-12">
        <h5 className="m-panel__subtitle">Vendor Details</h5>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label htmlFor="vendor_company_name">Vendor company name*</label>
          <Select
            id="vendor_company_name"
            className="form-control"
            showSearch
            placeholder="-- Please Select --"
            optionFilterProp="children"
            value={
              assetDetails?.VendorList.map((item) => {
                if (item.rowid == addForm.vendor)
                  return item.vendor_company_name;
              }).filter((item) => item != undefined)[0]
            }
            disabled
          >
            {" "}
            {assetDetails?.VendorList?.map((item) => (
              <Option key={item.vendor_id} value={item.vendor_id}>
                {item.vendor_company_name}
              </Option>
            ))}
          </Select>
          <ValidationsMessage
            field={addForm.vendor}
            isSubmit={isSubmit}
            message={"Please Select Vendor Company Name"}
          />
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label htmlFor="vendor_code">Vendor code*</label>
          <input
            id="vendor_code"
            type="text"
            className="form-control"
            disabled
            value={vendorInfo?.vendor_id}
          />
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label htmlFor="contact_name">Contact name*</label>
          <input
            id="contact_name"
            disabled
            value={vendorInfo?.contact_name1}
            type="text"
            className="form-control"
          />
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label htmlFor="mobile_number">Mobile number*</label>
          <input
            id="mobile_number"
            type="number"
            disabled
            value={vendorInfo?.mobile_number1}
            className="form-control"
          />
        </div>
      </div>
      <div className="col-md-4">
        <div className="form-group">
          <label htmlFor="vendor_email">Email*</label>
          <input
            id="vendor_email"
            type="email"
            disabled
            value={vendorInfo?.email_address1}
            className="form-control"
          />
        </div>
      </div>
    </div>
  );
}
